<template>
    <div class="col-sm-12">
        <h6 class="purpose">
            Select the date til which the user should be paused
        </h6>
        <div id="paused_till_date_selector">
            <div class="row">
                <div class="col-7">
                    <el-date-picker
                        v-model="pauseTill"
                        type="date"
                        placeholder="Select a date"
                        format="dd-MM-yyyy"
                        value-format="yyyy-MM-dd"
                        :clearable="false"
                        :editable="false"
                        :picker-options="datePickerOptions"
                        @change="pauseDateChanged($event)"
                    >
                    </el-date-picker>
                    <span v-if="showError" class="date-not-selected">You must select a date</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { DatePicker } from 'element-ui';
    import moment from 'moment';

    export default {
        props: {
            venueRep: {
                type: Object,
                required: true
            },
            showError: {
                type: Boolean,
                default:false
            }
        },
        components: {
            [DatePicker.name] : DatePicker,
        },
        data() {
            return {
                pauseTill: null,
                datePickerOptions: {
                    disabledDate(time) {
                        // Disable all dates prior today
                        return time.getTime() + 24 * 60 * 60 * 1000 < Date.now();
                    },
                }
            }
        },
        methods: {
            pauseDateChanged(newDate) {
                const formattedNewDate = ! newDate ? null : moment(newDate).format('DD-MM-YYYY');
                if (formattedNewDate != this.venueRep.distribution_rule?.paused_upto) {
                    this.$emit('update-pause-till-date', {id: this.venueRep.id, date: formattedNewDate})
                }
            }
        },
        computed: {
            paused_upto: function() {
                return this.venueRep.distribution_rule?.paused_upto;
            }
        },
        watch: {
            paused_upto: {
                handler: function (newVal) {
                    this.pauseTill = newVal;
                },
                immediate: true
            }
        }
    }
</script>

<style >
    .purpose {
        font-size: 14px;
        margin-bottom: 20px;
    }

    .date-not-selected {
        font-size: 12px;
        color: red;
        display: block;
        margin-top: 8px;
    }
</style>